/* Regenis mystery popup v4.0 (2026-07-10): Lirae-style rebuild (clone of the Alia
   popup on getlirae.com, measured live via computed styles):
   overlay rgba(0,0,0,.5); WHITE card 400x591, radius 0, no shadow, content column
   perfectly centered with 42px padding; close = 28px X top-right rgba(0,0,0,.4);
   logo img h26; "CONGRATULATIONS!" + "YOU'VE UNLOCKED / MYSTERY DISCOUNT" in
   Poppins 25/600 uppercase, 16px gaps; button 100% x 56, #C47245, radius 8,
   Poppins 17/600 white; "No thanks..." Poppins 12/600 rgba(124,124,124,.7).
   Stage 2: "Ready to see what you got?" 22/600 + email input (56h, radius 8,
   1px rgba(0,0,0,.4)) + GET DISCOUNT button. Stage 3: WELCOME10 code box +
   auto-apply + START SHOPPING. Chip after dismissal: bottom-LEFT 16/16, #C47245,
   radius 10, "Get Mystery Discount x", lifts above the sticky ATC bar.
   SAFETY (lessons from the 2026-07-09/10 freeze marathon):
   (1) NEVER runs inside the theme editor (Shopify.designMode guard) - the old
       popup fired on every editor load because the preview iframe has
       partitioned storage.
   (2) Scroll lock is SELF-HEALING: while we hold the lock, a 500ms guard checks
       the overlay is still in the DOM and force-unlocks if anything rips it out,
       so body position:fixed can never stick again.
   (3) RGX_POPUP_DISABLED one-flip kill-switch kept. To disarm the popup, set it
       to true - do NOT css-hide it (that is what froze the site: the JS kept
       arming an invisible overlay + scroll lock with unreachable close buttons).
   ?rgxpopup=1 forces (clears suppression). Suppression: completing = done
   forever; dismissing = 3-day auto-show pause + chip; chip x = hidden for the
   session. Keys unchanged from v3 so prior completions stay honored. */
(function () {
  var RGX_POPUP_DISABLED = false; /* kill-switch: set true to disarm site-wide */

  var DONE = 'rgxPopupDone';
  var LAST = 'rgxPopupLast';
  var CHIP_HIDE = 'rgxChipHide';
  var SUPPRESS_MS = 3 * 24 * 60 * 60 * 1000;
  var DELAY_MS = 12000;
  var CODE = 'WELCOME10';
  var TERRA = '#C47245';
  var TERRA_DARK = '#B3653C';
  var LOGO = 'https://cdn.shopify.com/s/files/1/0988/6993/6438/files/regenis-logo.png';
  var FORCE = /[?&]rgxpopup=1/.test(location.search);

  if (window.Shopify && window.Shopify.designMode) return; /* never in the theme editor */
  if (RGX_POPUP_DISABLED && !FORCE) return;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function isDone() { return lsGet(DONE) === '1'; }
  function shouldAutoShow() {
    if (isDone()) return false;
    var last = +lsGet(LAST) || 0;
    return Date.now() - last >= SUPPRESS_MS;
  }

  /* Shared refcounted lock from rgx-countdown.js (fallback = same behavior). */
  function getLock() {
    if (window.rgxScrollLock) return window.rgxScrollLock;
    var y = 0;
    return {
      lock: function () {
        y = window.scrollY || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = (-y) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.documentElement.style.overflow = 'hidden';
      },
      unlock: function () {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.documentElement.style.overflow = '';
        try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
      }
    };
  }

  /* Popup owns EXACTLY ONE lock reference, with a guard interval that force
     unlocks if the overlay leaves the DOM by any path (editor swaps, third
     party code, anything). Leak-proof by construction. */
  var myLock = false, healT = null;
  function plock() {
    if (myLock) return;
    myLock = true;
    getLock().lock();
    healT = setInterval(function () {
      if (!document.getElementById('rgx-popup-overlay')) punlock();
    }, 500);
  }
  function punlock() {
    if (!myLock) return;
    myLock = false;
    clearInterval(healT);
    getLock().unlock();
  }

  function applyDiscount() {
    var done = false;
    function viaFrame() {
      if (done) return;
      var fr = document.getElementById('rgx-disc-frame');
      if (!fr) {
        fr = document.createElement('iframe');
        fr.id = 'rgx-disc-frame';
        fr.style.display = 'none';
        document.body.appendChild(fr);
      }
      fr.src = '/discount/' + CODE + '?redirect=/cart';
    }
    try {
      fetch('/discount/' + CODE, { credentials: 'same-origin' })
        .then(function (r) { if (r && (r.ok || r.redirected)) done = true; else viaFrame(); })
        .catch(viaFrame);
      setTimeout(function () { if (!done) viaFrame(); }, 1500);
    } catch (e) { viaFrame(); }
  }

  function submitEmail(email) {
    return new Promise(function (resolve) {
      var f = document.getElementById('rgx-popup-capture');
      if (!f) { resolve(); return; }
      var ef = f.querySelector('input[name="contact[email]"]');
      if (ef) ef.value = email;
      var fr = document.getElementById('rgx-cap-frame');
      if (!fr) {
        fr = document.createElement('iframe');
        fr.id = 'rgx-cap-frame';
        fr.name = 'rgx-cap-frame';
        fr.style.display = 'none';
        document.body.appendChild(fr);
      }
      f.setAttribute('target', 'rgx-cap-frame');
      try { HTMLFormElement.prototype.submit.call(f); } catch (e) {}
      setTimeout(resolve, 600);
    });
  }

  function css() {
    if (!document.getElementById('rgx-poppins')) {
      var l = document.createElement('link');
      l.id = 'rgx-poppins';
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap';
      document.head.appendChild(l);
    }
    if (document.getElementById('rgx-popup-css')) return;
    var s = document.createElement('style');
    s.id = 'rgx-popup-css';
    s.textContent =
      '#rgx-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:10060;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .28s ease;overscroll-behavior:contain;}' +
      '#rgx-popup-overlay.rgx-in{opacity:1;}' +
      '#rgx-popup-overlay.rgx-out{opacity:0 !important;transition:opacity .2s ease !important;}' +
      '#rgx-popup{position:relative;background:#ffffff;width:400px;max-width:calc(100vw - 32px);height:591px;max-height:calc(100dvh - 32px);border-radius:0;box-shadow:none;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:42px;box-sizing:border-box;font-family:"Poppins",var(--font-body-family,sans-serif);text-align:center;}' +
      '#rgx-popup .rgx-pop__x{position:absolute;top:16px;right:16px;width:28px;height:28px;background:none;border:none;padding:0;cursor:pointer;color:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;}' +
      '#rgx-popup .rgx-pop__x svg{width:28px;height:28px;display:block;}' +
      '#rgx-popup .rgx-pop__logo{height:26px;width:auto;display:block;margin:0 auto 32px;}' +
      '#rgx-popup .rgx-pop__h{font-family:"Poppins",sans-serif;font-size:25px;line-height:30px;font-weight:600;color:#000000;text-transform:uppercase;margin:0 0 16px;letter-spacing:normal;}' +
      '#rgx-popup .rgx-pop__h + .rgx-pop__h{margin-top:-16px;}' +
      '#rgx-popup .rgx-pop__h2{font-family:"Poppins",sans-serif;font-size:22px;line-height:26px;font-weight:600;color:#000000;margin:0 0 26px;}' +
      '#rgx-popup .rgx-stage{width:100%;}' +
      '#rgx-popup .rgx-pop__btn{display:block;width:100%;height:56px;background:' + TERRA + ';color:#ffffff;border:none;border-radius:8px;font-family:"Poppins",sans-serif;font-size:17px;font-weight:600;letter-spacing:.01em;cursor:pointer;transition:background .15s ease;margin:0 0 16px;}' +
      '#rgx-popup .rgx-pop__btn:hover{background:' + TERRA_DARK + ';}' +
      '#rgx-popup .rgx-pop__btn--caps{text-transform:uppercase;}' +
      '#rgx-popup .rgx-pop__no{background:none;border:none;padding:0;font-family:"Poppins",sans-serif;font-size:12px;font-weight:600;color:rgba(124,124,124,.7);cursor:pointer;}' +
      '#rgx-popup .rgx-pop__input{display:block;width:100%;height:56px;box-sizing:border-box;border:1px solid rgba(0,0,0,.4);border-radius:8px;padding:0 18px;font-family:"Poppins",sans-serif;font-size:18px;color:#000000;background:#ffffff;outline:none;margin:0 0 12px;}' +
      '#rgx-popup .rgx-pop__input:focus{border-color:' + TERRA + ';}' +
      '#rgx-popup .rgx-pop__err{display:none;font-family:"Poppins",sans-serif;font-size:12px;font-weight:600;color:#B03A3A;margin:-4px 0 10px;}' +
      '#rgx-popup .rgx-pop__codebox{display:flex;align-items:center;justify-content:center;gap:12px;border:1.5px dashed ' + TERRA + ';border-radius:8px;padding:14px 16px;margin:0 0 14px;background:#FBF6F2;}' +
      '#rgx-popup .rgx-pop__code{font-family:"Poppins",sans-serif;font-size:20px;font-weight:700;letter-spacing:.1em;color:' + TERRA + ';}' +
      '#rgx-popup .rgx-pop__copy{background:' + TERRA + ';color:#fff;border:none;border-radius:6px;font-family:"Poppins",sans-serif;font-size:12px;font-weight:700;padding:8px 12px;cursor:pointer;}' +
      '#rgx-popup .rgx-pop__note{font-family:"Poppins",sans-serif;font-size:13px;line-height:1.45;color:#6b6b6b;margin:0 0 18px;}' +
      '#rgx-popup-chip{position:fixed;left:16px;right:auto;bottom:16px;z-index:10050;height:56px;background:' + TERRA + ';color:#ffffff;border-radius:10px;display:flex;align-items:center;box-shadow:0 3px 12px rgba(0,0,0,.18);overflow:hidden;}' +
      '#rgx-popup-chip .rgx-chip__main{background:none;border:none;color:#fff;font-family:"Poppins",sans-serif;font-weight:600;font-size:15px;padding:0 6px 0 20px;height:56px;cursor:pointer;white-space:nowrap;}' +
      '#rgx-popup-chip .rgx-chip__x{background:none;border:none;color:rgba(255,255,255,.9);font-size:18px;line-height:1;padding:0 16px 0 8px;height:56px;cursor:pointer;}' +
      'body:has(cart-drawer.active) #rgx-popup-chip{display:none;}' +
      'body:has(#rvsticky.is-visible) #rgx-popup-chip{bottom:calc(var(--rgx-sbh, 8.6rem) + 12px);}' +
      '@media (max-width:749px){' +
        '#rgx-popup{padding:34px 26px;}' +
        '#rgx-popup .rgx-pop__h{font-size:22px;line-height:27px;}' +
        '#rgx-popup-chip{left:12px;bottom:calc(12px + env(safe-area-inset-bottom));height:48px;}' +
        '#rgx-popup-chip .rgx-chip__main{font-size:13px;height:48px;padding:0 4px 0 16px;}' +
        '#rgx-popup-chip .rgx-chip__x{height:48px;font-size:16px;padding:0 13px 0 7px;}' +
        'body:has(#rvsticky.is-visible) #rgx-popup-chip{bottom:calc(var(--rgx-sbh, 13.5rem) + 10px);}' +
      '}';
    document.head.appendChild(s);
  }

  var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function removeChip() {
    var c = document.getElementById('rgx-popup-chip');
    if (c) c.remove();
  }

  function maybeChip() {
    if (isDone()) return;
    try { if (sessionStorage.getItem(CHIP_HIDE) === '1') return; } catch (e) {}
    if (document.getElementById('rgx-popup-chip')) return;
    css();
    var c = document.createElement('div');
    c.id = 'rgx-popup-chip';
    c.innerHTML = '<button class="rgx-chip__main" type="button">Get Mystery Discount</button><button class="rgx-chip__x" type="button" aria-label="Hide">\u2715</button>';
    document.body.appendChild(c);
    c.querySelector('.rgx-chip__main').addEventListener('click', function () { show(true); });
    c.querySelector('.rgx-chip__x').addEventListener('click', function () {
      try { sessionStorage.setItem(CHIP_HIDE, '1'); } catch (e) {}
      c.remove();
    });
  }

  function show(force) {
    if (document.getElementById('rgx-popup-overlay')) return;
    if (!force && document.querySelector('cart-drawer.active')) { setTimeout(function () { show(false); }, 8000); return; }
    css();
    removeChip(); /* chip never shows under the open popup; dismiss() re-adds it */
    var ov = document.createElement('div');
    ov.id = 'rgx-popup-overlay';
    ov.innerHTML =
      '<div id="rgx-popup" role="dialog" aria-modal="true" aria-label="Mystery discount">' +
        '<button class="rgx-pop__x" aria-label="Close">' + X_SVG + '</button>' +
        '<img class="rgx-pop__logo" src="' + LOGO + '" alt="Regenis">' +
        '<div class="rgx-stage rgx-stage--intro">' +
          '<p class="rgx-pop__h">Congratulations!</p>' +
          '<p class="rgx-pop__h">You\u2019ve Unlocked<br>Mystery Discount</p>' +
          '<button class="rgx-pop__btn rgx-yes" type="button">Yes, I want the discount.</button>' +
          '<button class="rgx-pop__no rgx-no" type="button">No thanks, I\u2019ll pay full price...</button>' +
        '</div>' +
        '<div class="rgx-stage rgx-stage--email" style="display:none;">' +
          '<p class="rgx-pop__h2">Ready to see what you got?</p>' +
          '<input class="rgx-pop__input rgx-email" type="email" placeholder="Your email address" autocomplete="email">' +
          '<p class="rgx-pop__err rgx-err-email">Please enter a valid email address.</p>' +
          '<button class="rgx-pop__btn rgx-pop__btn--caps rgx-go" type="button">Get Discount</button>' +
        '</div>' +
        '<div class="rgx-stage rgx-stage--code" style="display:none;">' +
          '<p class="rgx-pop__h">You unlocked 10% off!</p>' +
          '<div class="rgx-pop__codebox"><span class="rgx-pop__code">' + CODE + '</span><button class="rgx-pop__copy" type="button">Copy</button></div>' +
          '<p class="rgx-pop__note">Your discount is applied to your cart automatically \u2014 the code above is your backup.</p>' +
          '<button class="rgx-pop__btn rgx-pop__btn--caps rgx-done" type="button">Start Shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ov);
    plock();
    requestAnimationFrame(function () { ov.classList.add('rgx-in'); });
    setTimeout(function () { if (!ov.classList.contains('rgx-in')) ov.classList.add('rgx-in'); }, 120);

    var stages = {
      intro: ov.querySelector('.rgx-stage--intro'),
      email: ov.querySelector('.rgx-stage--email'),
      code: ov.querySelector('.rgx-stage--code')
    };
    function setStage(name) {
      Object.keys(stages).forEach(function (k) { stages[k].style.display = k === name ? 'block' : 'none'; });
    }

    var completed = false, dismissed = false;
    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      if (!completed) lsSet(LAST, String(Date.now()));
      ov.classList.add('rgx-out');
      ov.classList.remove('rgx-in');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { ov.remove(); punlock(); }, 220);
      if (completed) removeChip();
      else maybeChip();
    }
    function onKey(e) { if (e.key === 'Escape') dismiss(); }
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', function (e) { if (e.target === ov) dismiss(); });
    ov.querySelector('.rgx-pop__x').addEventListener('click', dismiss);
    ov.querySelector('.rgx-no').addEventListener('click', dismiss);
    ov.querySelector('.rgx-done').addEventListener('click', dismiss);

    ov.querySelector('.rgx-yes').addEventListener('click', function () {
      setStage('email');
      var inp = ov.querySelector('.rgx-email');
      setTimeout(function () { try { inp.focus(); } catch (e) {} }, 60);
    });

    function finish(email) {
      completed = true;
      lsSet(DONE, '1');
      removeChip();
      if (email) submitEmail(email);
      applyDiscount();
      setStage('code');
    }
    function go() {
      var inp = ov.querySelector('.rgx-email');
      var err = ov.querySelector('.rgx-err-email');
      var val = (inp.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) { err.style.display = 'block'; return; }
      err.style.display = 'none';
      finish(val);
    }
    ov.querySelector('.rgx-go').addEventListener('click', go);
    ov.querySelector('.rgx-email').addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });

    ov.querySelector('.rgx-pop__copy').addEventListener('click', function () {
      var b = this;
      function ok() { b.textContent = 'Copied!'; setTimeout(function () { b.textContent = 'Copy'; }, 1600); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(ok).catch(ok);
      else ok();
    });
  }

  function init() {
    if (FORCE) {
      lsDel(DONE); lsDel(LAST);
      try { sessionStorage.removeItem(CHIP_HIDE); } catch (e) {}
      setTimeout(function () { show(true); }, 800);
      return;
    }
    if (isDone()) return;
    if (shouldAutoShow()) setTimeout(function () { show(false); }, DELAY_MS);
    else maybeChip();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
